import { type QuantitativeValue } from 'schema-dts'

import { type PimPackageSizeV1 } from '@redteclab/api/clients/bully'

export const getEligibleQuantitySchema = (
  packageSize: PimPackageSizeV1,
): QuantitativeValue => ({
  '@type': 'QuantitativeValue',
  name: `${packageSize.value} ${packageSize.unit}`,
})
